import React from "react";
import LiveTokenCard from "../components/liveTokenCard";
import MediaQuery from 'react-responsive';
import { useEffect, useState, useRef } from "react";
import { ethers } from "ethers";
import CypherDudesArtifact from '../web3/abi/CypherDudes.json';
import CypherDudesBitArtifact from '../web3/abi/CypherDudesBit.json';
import CypherPalacesArtifact from '../web3/abi/CypherPalaces.json';
import { contractAddresses } from '../web3/contractsAddresses';
import { v4 as uuidv4 } from 'uuid';
import { breakpoints } from "../components/constants";
import { useParams } from 'react-router-dom';
import { infuraProvider } from "../web3/providers";
import { useDebouncedEffect, useRpcGuard } from "../web3/useDebouncedCall";
import { ReactComponent as Loader } from '../components/svg/loader.svg';
import { ReactComponent as Connect } from '../components/svg/connect.svg';

import Modal from 'react-modal';



import Background from "../components/background";

import { createWeb3Modal, defaultConfig, useWeb3Modal, useWeb3ModalAccount, useWeb3ModalProvider } from "@web3modal/ethers/react";

const ERROR_CODE_TX_REJECTED_BY_USER = 4001;

const CypherPagerABI = [
    "function mint(uint256 tokenId) payable",
    "function balanceOf(address owner) view returns (uint256)",
    "function totalSupply() view returns (uint256)",
    "function claimStarted() view returns (bool)",
    "function teamAllowance(address) view returns (uint256)"
];

const PAGER_MINT_PRICE = '0.01024';

// Team wallets reserved for free mints (see teamAllowance in CypherPager.sol).
const TEAM_ADDRESSES = [
    "0x54DEd7088B5E303dDd63e15c95F502B4c0c61627",
    "0x0390eE820886e9f614134d8eA6E682EAAF9Bbb1e",
    "0x1689B564814db5f1C7Abd74129771D282E2d652b",
    "0x4962Aa766f1a29b3E1C5a6dd049829D593A0269d",
    "0x07f5eed859Ea472b8e6eaE454710554C78F25ad5"
].map((a) => a.toLowerCase());

const ERC6551RegistryABI = [
    "function account(address implementation, bytes32 salt, uint256 chainId, address tokenContract, uint256 tokenId) view returns (address)"
];

// DOS helper contract — every owned id across CypherDudes + CypherDudesBit
// in a single eth_call (replaces the paginated Alchemy getNftsForOwner loops).
const OwnedTokensABI = [
    "function tokensOfOwner(address owner) view returns (uint256[])"
];

// First CypherDudesBit id — ids below live in the OG contract.
const BIT_START_ID = 1728;

const utilities = require("../components/utilities");



const MyCypherdudes = () => {
    const [supply, setSupply] = useState(0);
    const [mintStatus, setMintStatus] = useState(false);
    const [txStatus, setTxStatus] = useState('idle');
    const [tokens, setTokens] = useState([]);
    const [balance, setBalance] = useState(0);
    const [bitBalance, setBitBalance] = useState(0);
    const [teamAllowance, setTeamAllowance] = useState(0);
    const [txError, setTxError] = useState(undefined);
    const [loadStatus, setLoadStatus] = useState(false);
    const [tokenIds, setTokenIds] = useState([]);
    const [itemPerPage, setItemPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPage] = useState(1);
    const [sliderRange, setSliderRange] = useState(10);
    const [inputValue, setInputValue] = useState(10);
    const sliderRef = useRef(null);
    const fetchSeq = useRef(0);
    const guard = useRpcGuard();

    const { address, chainId, isConnected } = useWeb3ModalAccount();
    const { walletProvider } = useWeb3ModalProvider()
    const provider = new ethers.BrowserProvider(walletProvider);

    const cypherDudesReadContract = new ethers.Contract(
        contractAddresses.CypherDudes,
        CypherDudesArtifact.abi,
        infuraProvider
    );

    const cypherDudesBitReadContract = new ethers.Contract(
        contractAddresses.CypherDudesBit,
        CypherDudesBitArtifact.abi,
        infuraProvider
    );

    const cypherPalacesContract = new ethers.Contract(
        contractAddresses.CypherPalaces,
        CypherPalacesArtifact.abi,
        infuraProvider
    );

    const cypherPagerReadContract = new ethers.Contract(
        contractAddresses.CypherPager,
        CypherPagerABI,
        infuraProvider
    );

    const registryReadContract = new ethers.Contract(
        contractAddresses.ERC6551Registry,
        ERC6551RegistryABI,
        infuraProvider
    );

    const ownedTokensReadContract = new ethers.Contract(
        contractAddresses.OwnedTokens,
        OwnedTokensABI,
        infuraProvider
    );

    const [modalIsOpen, setIsOpen] = useState(false);
    let subtitle;
    const customStyles = {
        overlay: {
            position: 'fixed',
            inset: '0px',
            backgroundColor: '#000000B3'
        },
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            border: '1px solid #00ff00',
            background: '#000',
            borderRadius: '0px',
            transform: 'translate(-50%, -50%)',
        },
    };

    // One debounced bootstrap: fires once ~400ms after the last change of
    // address/isConnected, so "mount" + "wallet connects" collapse into a
    // single run instead of the previous 3 overlapping effects. No polling —
    // supply/mintStatus/teamAllowance are re-read after each mint tx instead.
    useDebouncedEffect(() => {
        getMintStatus();
        _updateSupply();
        if (!isConnected || !address) return;
        guard('bootstrap', async () => {
            await _getTokensCount();
            getTeamAllowance();
        });
    }, [address, isConnected]);

    // tokenIds + currentPage merged: previously both effects called
    // _getTokensOfOwner, doubling every load.
    useDebouncedEffect(() => {
        if (tokenIds.length === 0) return;
        _getTokensOfOwner();
    }, [tokenIds, currentPage], 200);

    // useEffect(() => {
    //     _getTokensOfOwner();
    //     _getTotalPages();
    // }, [itemPerPage]);

    useEffect(() => {
        if (loadStatus) {
            setTimeout(() => {
                //saveThumbnail();
            }, 1000);
        }
    }, [loadStatus]);

    useEffect(() => {
        var status = document.getElementById('status')
        if (status != null) {
            var statusBtn = document.getElementById('statusBtn')
            status.innerHTML = txStatus;
            statusBtn.style.display = 'block';
        }
    }, [txStatus]);

    function openModal() {
        setIsOpen(true);
    }

    function afterOpenModal() {
        subtitle.style.color = '#00ff00';
    }

    function closeModal() {
        setIsOpen(false);
    }

    
    

    // Single eth_call to the OwnedTokens helper: replaces the two paginated
    // Alchemy getNftsForOwner loops AND the two balanceOf calls.
    const _getTokensCount = async () => {
        if (!isConnected || !address) {
            return;
        }
        try {
            const ids = await ownedTokensReadContract.tokensOfOwner(address);
            const allTokens = ids.map((id) => ({ tokenId: Number(id) }));
            setTokenIds(allTokens);
            const pages = Math.max(1, Math.ceil(allTokens.length / itemPerPage));
            setTotalPage(pages);
            setBalance(allTokens.filter((t) => t.tokenId < BIT_START_ID).length);
            setBitBalance(allTokens.filter((t) => t.tokenId >= BIT_START_ID).length);
        } catch (error) {
            console.log(error);
        }
    }

    const _getTotalPages = () => {
        const pages = Math.ceil(tokenIds.length / itemPerPage);
        setTotalPage(pages);
    }

    const _hasPager = async (tokenId) => {
        try {
            const cydContractAddress = tokenId < 1728 ? contractAddresses.CypherDudes : contractAddresses.CypherDudesBit;
            const tba = await registryReadContract.account(contractAddresses.ERC6551AccountProxy, ethers.ZeroHash, 1, cydContractAddress, tokenId);
            const pagerBalance = await cypherPagerReadContract.balanceOf(tba);
            return Number(pagerBalance) > 0;
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    const _getTokensOfOwner = async () => {
        if (!isConnected) {
            return;
        }
        // Sequence guard: if a newer run starts (page change while this one is
        // still streaming tokens), this one stops writing state immediately —
        // no more two loops racing and doubling every per-token call.
        const seq = ++fetchSeq.current;
        try {
            setTokens([]);

            const displayedTokens = tokenIds.slice(currentPage * itemPerPage, (currentPage + 1) * itemPerPage);

            let fetchedTokens = [];
            for (let i = 0; i < displayedTokens.length; i++) {
                if (seq !== fetchSeq.current) return;
                const tokenId = displayedTokens[i].tokenId;
                const readContract = tokenId < BIT_START_ID ? cypherDudesReadContract : cypherDudesBitReadContract;
                try {
                    // The 3 per-token reads are independent — run them in parallel.
                    const [tokenURI, palaceID, hasPager] = await Promise.all([
                        readContract.tokenURI(tokenId),
                        cypherPalacesContract.palaceFromCyd(tokenId),
                        _hasPager(tokenId)
                    ]);
                    const tokenURIDecoded = utilities.parseBase64DataURI(tokenURI);
                    const tokenURIJSONDecoded = JSON.parse(tokenURIDecoded);
                    const animationURL = utilities.parseBase64DataURI(tokenURIJSONDecoded.animation_url);
                    const tokenEntry = {
                        id: uuidv4(),
                        tokenId: tokenId.toString(),
                        name: tokenURIJSONDecoded.name,
                        traits: tokenURIJSONDecoded.attributes,
                        animationURL: animationURL,
                        palaceId: palaceID,
                        hasPager: hasPager
                    }
                    if (seq !== fetchSeq.current) return;
                    fetchedTokens.push(tokenEntry);
                    setTokens([...fetchedTokens]);
                } catch (error) {
                    console.log(error)
                }
                // ~4 eth_calls per token; pace them to stay under Infura's
                // per-second throughput instead of triggering -32005 bursts.
                await sleep(150);
            }
            setLoadStatus(true);
        } catch (error) {
            console.log(error);
            setTxError(error);
        }
    }

    const _updateSupply = async () => {
        try {
            const _supply = await cypherPagerReadContract.totalSupply();
            setSupply(Number(_supply));
        } catch (error) {
            console.log(error);
        }
    }

    const getMintStatus = async () => {
        try {
            const _mintStatus = await cypherPagerReadContract.claimStarted();
            setMintStatus(_mintStatus);
        } catch (error) {
            // CypherPager mint is open
            setMintStatus(true);
        }
    }

    const getTeamAllowance = async () => {
        if (!isConnected || !address) {
            setTeamAllowance(0);
            return;
        }
        try {
            const _allowance = await cypherPagerReadContract.teamAllowance(address);
            setTeamAllowance(Number(_allowance));
        } catch (error) {
            console.log(error);
            setTeamAllowance(0);
        }
    }

    const _dismissTransactionError = () => {
        setTxError(undefined);
    }

    const claimPalace = async (tokenId) => {
        console.log(`Claiming Palace for CYPHERDUDE #${tokenId}`);
        if (!isConnected) {
            alert('connect your wallet');
            return;
        }
        else if (chainId != 1) {
            alert('switch to ethereum mainnet');
            return;
        }
        else {
            try {
                openModal();
                setTxStatus('Mint intiated')
                const signer = await provider.getSigner();
                const cypherPalacesContract = new ethers.Contract(
                    contractAddresses.CypherPalaces,
                    CypherPalacesArtifact.abi,
                    signer
                );
                _dismissTransactionError();
                const cost = balance + bitBalance < 3 ? 0.0512 : 0.0420;
                console.log(ethers.parseEther((cost).toFixed(6).toString()));
                const tx = await cypherPalacesContract.claimPalace(tokenId, { value: ethers.parseEther((cost).toFixed(6).toString()) });
                const receipt = await tx.wait();
                if (receipt.status === 0) {
                    setTxStatus('transaction failed');
                    throw new Error("transaction failed");
                }
                setTxStatus('Mint sucessfull');
                await _updateSupply();
            } catch (error) {

                if (error.code === ERROR_CODE_TX_REJECTED_BY_USER) {
                    setTxStatus('Transaction canceled by the user');
                    return;
                }
                const decodedError = cypherPalacesContract.interface.parseError(error.data)
                setTxStatus('Transaction failed : ' + decodedError?.args)
                console.log(error);
                setTxError(error);
            } finally {
            }
        }
    }

    const mintPager = async (tokenId) => {
        console.log(`Minting Pager for CYPHERDUDE #${tokenId}`);
        if (!isConnected) {
            alert('connect your wallet');
            return;
        }
        else if (chainId != 1) {
            alert('switch to ethereum mainnet');
            return;
        }
        else {
            try {
                openModal();
                setTxStatus('Mint initiated')
                const signer = await provider.getSigner();
                const cypherPagerContract = new ethers.Contract(
                    contractAddresses.CypherPager,
                    CypherPagerABI,
                    signer
                );
                _dismissTransactionError();
                // Team wallets with remaining allowance mint for free (value 0);
                // everyone else pays the regular price. Read fresh on-chain to
                // avoid sending the wrong value if the allowance just changed.
                let mintValue = ethers.parseEther(PAGER_MINT_PRICE);
                try {
                    const _allowance = await cypherPagerReadContract.teamAllowance(address);
                    if (Number(_allowance) > 0) {
                        mintValue = 0n;
                    }
                } catch (error) {
                    console.log(error);
                }
                const tx = await cypherPagerContract.mint(tokenId, { value: mintValue });
                const receipt = await tx.wait();
                if (receipt.status === 0) {
                    setTxStatus('transaction failed');
                    throw new Error("transaction failed");
                }
                setTxStatus('Mint sucessfull');
                await _updateSupply();
                await getTeamAllowance();
                _getTokensOfOwner();
            } catch (error) {
                if (error.code === ERROR_CODE_TX_REJECTED_BY_USER) {
                    setTxStatus('Transaction canceled by the user');
                    return;
                }
                setTxStatus('Transaction failed');
                console.log(error);
                setTxError(error);
            } finally {
            }
        }
    }

    function handleSliderInput() {
        const range = 50 - 1;
        const distance = sliderRef.current.value - 0;
        const percentage = (distance / range) * 100;
        setSliderRange(percentage);
        setInputValue(sliderRef.current.value);
        setItemPerPage(sliderRef.current.value);
        const pages = Math.ceil(tokenIds.length / itemPerPage)
        setTotalPage(pages);
    }

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

    document.addEventListener("mousemove", function (event) {
        if (document.getElementById("desktopMenu") != null) {
            const nav = document.getElementById("navMenu");
            nav.style.transform = "translateY(0)";
            nav.style.transition = "transform 0.3s ease-in-out";
        }
    })

    return (
        <div>
            <Background />
            <Modal
                isOpen={modalIsOpen}
                onAfterOpen={afterOpenModal}
                style={customStyles}
                contentLabel="Inscription Complete">
                <h2 id="status" ref={(_subtitle) => (subtitle = _subtitle)}>Mint initiated...</h2>
                <button id="statusBtn" className="uxBtn modal" onClick={closeModal}>CLOSE</button>
            </Modal>
            <div className="tokenContainer">
                {
                    !mintStatus ?
                        <div className="highlightInfo"><p>CYPHERPAGERS mint has not started yet</p><p>Price : 0.01024 each</p><p>Minting a Cypherpager will permanently attach it to the selected Cypherdude (it's a Soulbound token that will be minted to the token bound wallet of your cypherdudes).</p><p>CLAIMING A WORD UNLOCKS THE MINT</p></div>
                        :
                        <div className="highlightInfo"><p>CYPHERPAGERS MINT IS LIVE !{supply > 0 ? ` ${supply} minted` : ''}</p><p>Price : 0.01024 each</p><p>Minting a Cypherpager will permanently attach it to the selected Cypherdude (it's a Soulbound token that will be minted to the token bound wallet of your cypherdudes).</p><p>CLAIMING A WORD UNLOCKS THE MINT</p></div>
                }
                {isConnected && address && TEAM_ADDRESSES.includes(address.toLowerCase()) &&
                    <div className="highlightInfo"><p>{`TEAM WALLET — ${teamAllowance} FREE MINT${teamAllowance === 1 ? '' : 'S'} REMAINING`}</p></div>
                }
                {isConnected ? tokens.length < 1 ?
                    <div>
                        <p className="highlight">Fetching your Cypherdudes from the blockchain, This can take a while...</p>
                        <div className="loader">
                            <Loader />
                        </div>
                    </div>
                    :
                    <div>
                        <p className="highlight">{`You own ${balance + bitBalance} cypherdude${(balance + bitBalance) < 2 ? '' : 's'}`}</p>
                        <div className="adminTools">
                            <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 0} className="uxBtn">PREVIOUS</button>
                            <p>{itemPerPage} per page ({currentPage+1} / {totalPages})</p>
                            <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage >= totalPages - 1} className="uxBtn">NEXT</button>
                            {/* <div className='range-slider-sm'>
                                <div className='slider-container'>
                                    <input type="range" onChange={(e)=>setInputValue(e.target.value)} onMouseUp={handleSliderInput} onTouchEnd={handleSliderInput}  value={inputValue} min={1} max={50} step={1} ref={sliderRef} className='slider' />
                                    <div className='slider-thumb' style={{ left: `calc(${sliderRange}% - 0.5em)` }}></div>
                                    <div className='progress' style={{ width: `${sliderRange}%` }}></div>
                                </div>
                            </div> */}
                        </div>
                        <div>
                            {
                                tokens.map((token, id) => {
                                    return <LiveTokenCard tokens={token} key={id} mint={mintPager} />
                                })
                            }
                        </div>
                    </div>
                    :
                    <div>
                        <p className="highlight">Connect your wallet to browse your Cypherdudes</p>
                        <div className="loader">
                            <Connect />
                        </div>
                    </div>
                }

            </div>
        </div>
    )
}

export default MyCypherdudes;